import { flowLog } from "../../utils/flowLog";
import { ChatFlowRole } from "./types";

type ChatLogPayload = {
  action: string;
  role: ChatFlowRole;
  consultationId?: string | number | null;
  appointmentId?: number | null;
  messageId?: number;
  unreadCount?: number;
  messagesCount?: number;
  socketId?: string;
  reason?: string;
  attemptNumber?: number;
};

export const chatFlowLog = (
  scope: string,
  message: string,
  payload: ChatLogPayload,
) => {
  flowLog(`${scope}][CHAT`, message, {
    screen: "CHAT",
    ...payload,
  });
};
